export const CHECK_SUBDOMAIN_AVAILABILITY_START = 'CHECK_SUBDOMAIN_AVAILABILITY_START';
export const CHECK_SUBDOMAIN_AVAILABILITY_ERROR = 'CHECK_SUBDOMAIN_AVAILABILITY_ERROR';
export const CHECK_SUBDOMAIN_AVAILABILITY_SUCCESSFUL = 'CHECK_SUBDOMAIN_AVAILABILITY_SUCCESSFUL';
export const CLEAR_CHECK_SUBDOMAIN_AVAILABILITY_STORE = 'CLEAR_CHECK_SUBDOMAIN_AVAILABILITY_STORE';

export const CHECK_SUBDOMAIN_AND_EMAIL_AVAILABILITY_START = 'CHECK_SUBDOMAIN_AND_EMAIL_AVAILABILITY_START';
export const CHECK_SUBDOMAIN_AND_EMAIL_AVAILABILITY_ERROR = 'CHECK_SUBDOMAIN_AND_EMAIL_AVAILABILITY_ERROR';
export const CHECK_SUBDOMAIN_AND_EMAIL_AVAILABILITY_SUCCESSFUL = 'CHECK_SUBDOMAIN_AND_EMAIL_AVAILABILITY_SUCCESSFUL';
export const CLEAR_SUBDOMAIN_AND_EMAIL_AVAILABILITY_STORE = 'CLEAR_SUBDOMAIN_AND_EMAIL_AVAILABILITY_STORE';

export const INSTANCE_REGISTER_START = 'INSTANCE_REGISTER_START';
export const INSTANCE_REGISTER_SUCCESSFUL = 'INSTANCE_REGISTER_SUCCESSFUL';
export const INSTANCE_REGISTER_ERROR = 'INSTANCE_REGISTER_ERROR';
export const CLEAR_INSTANCE_REGISTER_STORE = 'CLEAR_INSTANCE_REGISTER_STORE';

export const INSTANCE_SUBSCRIPTION_OPTIONS_START = 'INSTANCE_SUBSCRIPTION_OPTIONS_START';
export const INSTANCE_SUBSCRIPTION_OPTIONS_SUCCESSFUL = 'INSTANCE_SUBSCRIPTION_OPTIONS_SUCCESSFUL';
export const INSTANCE_SUBSCRIPTION_OPTIONS_ERROR = 'INSTANCE_SUBSCRIPTION_OPTIONS_ERROR';
export const CLEAR_INSTANCE_SUBSCRIPTION_OPTIONS_STORE = 'CLEAR_INSTANCE_SUBSCRIPTION_OPTIONS_STORE';

export const INSTANCE_SUBSCRIPTION_REVIEW_START = 'INSTANCE_SUBSCRIPTION_REVIEW_START';
export const INSTANCE_SUBSCRIPTION_REVIEW_SUCCESSFUL = 'INSTANCE_SUBSCRIPTION_REVIEW_SUCCESSFUL';
export const INSTANCE_SUBSCRIPTION_REVIEW_ERROR = 'INSTANCE_SUBSCRIPTION_REVIEW_ERROR';
export const CLEAR_INSTANCE_SUBSCRIPTION_REVIEW_STORE = 'CLEAR_INSTANCE_SUBSCRIPTION_REVIEW_STORE';

export const SAVE_INSTANCE_SUBSCRIPTION_SELECTION_START = 'SAVE_INSTANCE_SUBSCRIPTION_SELECTION_START';
export const SAVE_INSTANCE_SUBSCRIPTION_SELECTION_SUCCESSFUL = 'SAVE_INSTANCE_SUBSCRIPTION_SELECTION_SUCCESSFUL';
export const SAVE_INSTANCE_SUBSCRIPTION_SELECTION_ERROR = 'SAVE_INSTANCE_SUBSCRIPTION_SELECTION_ERROR';

export const FETCH_INSTANCE_DETAILS_START = 'FETCH_INSTANCE_DETAILS_START';
export const RECEIVE_INSTANCE_DETAILS = 'RECEIVE_INSTANCE_DETAILS';
export const FETCH_INSTANCE_DETAILS_NOT_FOUND = 'FETCH_INSTANCE_DETAILS_NOT_FOUND';
export const FETCH_INSTANCE_DETAILS_ERROR = 'FETCH_INSTANCE_DETAILS_ERROR';

export const SAVE_INSTANCE_DETAILS_START = 'SAVE_INSTANCE_DETAILS_START';
export const SAVE_INSTANCE_DETAILS_SUCCESSFUL = 'SAVE_INSTANCE_DETAILS_SUCCESSFUL';
export const SAVE_INSTANCE_DETAILS_ERROR = 'SAVE_INSTANCE_DETAILS_ERROR';

export const SAVE_INSTANCE_LOGO_START = 'SAVE_INSTANCE_LOGO_START';
export const SAVE_INSTANCE_LOGO_DONE = 'SAVE_INSTANCE_LOGO_DONE';
export const SAVE_INSTANCE_LOGO_ERROR = 'SAVE_INSTANCE_LOGO_ERROR';

export const REMOVE_INSTANCE_LOGO_START = 'REMOVE_INSTANCE_LOGO_START';
export const REMOVE_INSTANCE_LOGO_DONE = 'REMOVE_INSTANCE_LOGO_DONE';
export const REMOVE_INSTANCE_LOGO_ERROR = 'REMOVE_INSTANCE_LOGO_ERROR';

export const CHANGE_INSTANCE_OWNER_EMAIL = 'CHANGE_INSTANCE_OWNER_EMAIL';

export const CLEAR_INSTANCE_DETAILS_STORE = 'CLEAR_INSTANCE_DETAILS_STORE';

export const INSTANCE_REGISTRATION_CHECKOUT_START = 'INSTANCE_REGISTRATION_CHECKOUT_START';
export const INSTANCE_REGISTRATION_CHECKOUT_ERROR = 'INSTANCE_REGISTRATION_CHECKOUT_ERROR';
export const INSTANCE_REGISTRATION_CHECKOUT_SUCCESSFUL = 'INSTANCE_REGISTRATION_CHECKOUT_SUCCESSFUL';
export const CLEAR_INSTANCE_REGISTRATION_CHECKOUT_STORE = 'CLEAR_INSTANCE_REGISTRATION_CHECKOUT_STORE';

export const FETCH_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE_START = 'FETCH_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE_START';
export const FETCH_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE_ERROR = 'FETCH_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE_ERROR';
export const RECEIVE_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE = 'RECEIVE_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE';
export const CLEAR_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE_STORE = 'CLEAR_INSTANCE_SETTINGS_REGINAL_AND_LANGUAGE_STORE';

export const FETCH_INSTANCE_SOURCES_LIST_START = 'FETCH_INSTANCE_SOURCES_LIST_START';
export const FETCH_INSTANCE_SOURCES_LIST_ERROR = 'FETCH_INSTANCE_SOURCES_LIST_ERROR';
export const RECEIVE_INSTANCE_SOURCES_LIST = 'RECEIVE_INSTANCE_SOURCES_LIST';
export const CLEAR_INSTANCE_SOURCES_LIST_STORE = 'CLEAR_INSTANCE_SOURCES_LIST_STORE';

export const FETCH_INSTANCE_SOURCE_DETAILS_START = 'FETCH_INSTANCE_SOURCE_DETAILS_START';
export const FETCH_INSTANCE_SOURCE_DETAILS_ERROR = 'FETCH_INSTANCE_SOURCE_DETAILS_ERROR';
export const FETCH_INSTANCE_SOURCE_DETAILS_NOT_FOUND = 'FETCH_INSTANCE_SOURCE_DETAILS_NOT_FOUND';
export const RECEIVE_INSTANCE_SOURCE_DETAILS = 'RECEIVE_INSTANCE_SOURCE_DETAILS';
export const CLEAR_INSTANCE_SOURCE_DETAILS_STORE = 'CLEAR_INSTANCE_SOURCE_DETAILS_STORE';

export const FETCH_INSTANCE_SUBSCRIPTION_INVOICES_LIST_START = 'FETCH_INSTANCE_SUBSCRIPTION_INVOICES_LIST_START';
export const FETCH_INSTANCE_SUBSCRIPTION_INVOICES_LIST_ERROR = 'FETCH_INSTANCE_SUBSCRIPTION_INVOICES_LIST_ERROR';
export const RECEIVE_INSTANCE_SUBSCRIPTION_INVOICES_LIST = 'RECEIVE_INSTANCE_SUBSCRIPTION_INVOICES_LIST';
export const CLEAR_INSTANCE_SUBSCRIPTION_INVOICES_LIST_STORE = 'CLEAR_INSTANCE_SUBSCRIPTION_INVOICES_LIST_STORE';
export const UPDATE_INSTANCE_SOURCE_AND_FEATURES_LIST = 'UPDATE_INSTANCE_SOURCE_AND_FEATURES_LIST';

export const FETCH_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_START = 'FETCH_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_START';
export const FETCH_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_ERROR = 'FETCH_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_ERROR';
export const FETCH_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_NOT_FOUND = 'FETCH_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_NOT_FOUND';
export const RECEIVE_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS = 'RECEIVE_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS';
export const CLEAR_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_STORE = 'CLEAR_INSTANCE_SUBSCRIPTION_INVOICE_DETAILS_STORE';

export const ACTIVATE_INSTANCE_SOURCE_START = 'ACTIVATE_INSTANCE_SOURCE_START';
export const ACTIVATE_INSTANCE_SOURCE_SUCCESSFUL = 'ACTIVATE_INSTANCE_SOURCE_SUCCESSFUL';
export const ACTIVATE_INSTANCE_SOURCE_ERROR = 'ACTIVATE_INSTANCE_SOURCE_ERROR';

export const DEACTIVATE_INSTANCE_SOURCE_START = 'DEACTIVATE_INSTANCE_SOURCE_START';
export const DEACTIVATE_INSTANCE_SOURCE_SUCCESSFUL = 'DEACTIVATE_INSTANCE_SOURCE_SUCCESSFUL';
export const DEACTIVATE_INSTANCE_SOURCE_ERROR = 'DEACTIVATE_INSTANCE_SOURCE_ERROR';

export const FETCH_INSTANCE_SUBSCRIPTIONS_LIST_START = 'FETCH_INSTANCE_SUBSCRIPTIONS_LIST_START';
export const FETCH_INSTANCE_SUBSCRIPTIONS_LIST_ERROR = 'FETCH_INSTANCE_SUBSCRIPTIONS_LIST_ERROR';
export const RECEIVE_INSTANCE_SUBSCRIPTIONS_LIST = 'RECEIVE_INSTANCE_SUBSCRIPTIONS_LIST';
export const CLEAR_INSTANCE_SUBSCRIPTIONS_LIST_STORE = 'CLEAR_INSTANCE_SUBSCRIPTIONS_LIST_STORE';

export const FETCH_INSTANCE_SUBSCRIPTION_DETAILS_START = 'FETCH_INSTANCE_SUBSCRIPTION_DETAILS_START';
export const FETCH_INSTANCE_SUBSCRIPTION_DETAILS_ERROR = 'FETCH_INSTANCE_SUBSCRIPTION_DETAILS_ERROR';
export const FETCH_INSTANCE_SUBSCRIPTION_DETAILS_NOT_FOUND = 'FETCH_INSTANCE_SUBSCRIPTION_DETAILS_NOT_FOUND';
export const RECEIVE_INSTANCE_SUBSCRIPTION_DETAILS = 'RECEIVE_INSTANCE_SUBSCRIPTION_DETAILS';
export const CLEAR_INSTANCE_SUBSCRIPTION_DETAILS_STORE = 'CLEAR_INSTANCE_SUBSCRIPTION_DETAILS_STORE';

export const INSTANCE_REGISTRATION_PRE_COMPLETION_START = 'INSTANCE_REGISTRATION_PRE_COMPLETION_START';
export const INSTANCE_REGISTRATION_PRE_COMPLETION_ERROR = 'INSTANCE_REGISTRATION_PRE_COMPLETION_ERROR';
export const INSTANCE_REGISTRATION_PRE_COMPLETION_SUCCESSFUL = 'INSTANCE_REGISTRATION_PRE_COMPLETION_SUCCESSFUL';
export const CLEAR_INSTANCE_REGISTRATION_PRE_COMPLETION_STORE = 'CLEAR_INSTANCE_REGISTRATION_PRE_COMPLETION_STORE';

export const INSTANCE_REGISTRATION_COMPLETION_START = 'INSTANCE_REGISTRATION_COMPLETION_START';
export const INSTANCE_REGISTRATION_COMPLETION_ERROR = 'INSTANCE_REGISTRATION_COMPLETION_ERROR';
export const INSTANCE_REGISTRATION_COMPLETION_SUCCESSFUL = 'INSTANCE_REGISTRATION_COMPLETION_SUCCESSFUL';
export const CLEAR_INSTANCE_REGISTRATION_COMPLETION_STORE = 'CLEAR_INSTANCE_REGISTRATION_COMPLETION_STORE';

export const FETCH_INSTANCE_INFO_START = 'FETCH_INSTANCE_INFO_START';
export const FETCH_INSTANCE_INFO_ERROR = 'FETCH_INSTANCE_INFO_ERROR';
export const FETCH_INSTANCE_INFO_NOT_FOUND = 'FETCH_INSTANCE_INFO_NOT_FOUND';
export const RECEIVE_INSTANCE_INFO = 'RECEIVE_INSTANCE_INFO';
export const CLEAR_INSTANCE_INFO_STORE = 'CLEAR_INSTANCE_INFO_STORE';
export const UPDATE_INSTANCE_INFO = 'UPDATE_INSTANCE_INFO';

export const INSTANCE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_START = 'INSTANCE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_START';
export const INSTANCE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_ERROR = 'INSTANCE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_ERROR';
export const INSTANCE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_SUCCESSFUL = 'INSTANCE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_SUCCESSFUL';
export const CLEAR_INSTANCEE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_STORE = 'CLEAR_INSTANCEE_PLAN_PURCHASE_SUBSCRIPTION_OPTIONS_STORE';

export const INSTANCE_PLAN_SAVE_PURCHASE_SUBSCRIPTION_SELECTION_START = 'INSTANCE_PLAN_SAVE_PURCHASE_SUBSCRIPTION_SELECTION_START';
export const INSTANCE_PLAN_SAVE_PURCHASE_SUBSCRIPTION_SELECTION_ERROR = 'INSTANCE_PLAN_SAVE_PURCHASE_SUBSCRIPTION_SELECTION_ERROR';
export const INSTANCE_PLAN_SAVE_PURCHASE_SUBSCRIPTION_SELECTION_SUCCESSFUL = 'INSTANCE_PLAN_SAVE_PURCHASE_SUBSCRIPTION_SELECTION_SUCCESSFUL';

export const INSTANCE_PLAN_PURCHASE_FINAL_REVIEW_START = 'INSTANCE_PLAN_PURCHASE_FINAL_REVIEW_START';
export const INSTANCE_PLAN_PURCHASE_FINAL_REVIEW_ERROR = 'INSTANCE_PLAN_PURCHASE_FINAL_REVIEW_ERROR';
export const INSTANCE_PLAN_PURCHASE_FINAL_REVIEW_SUCCESSFUL = 'INSTANCE_PLAN_PURCHASE_FINAL_REVIEW_SUCCESSFUL';
export const CLEAR_INSTANCEE_PLAN_PURCHASE_FINAL_REVIEW_STORE = 'CLEAR_INSTANCEE_PLAN_PURCHASE_FINAL_REVIEW_STORE';

export const INSTANCE_PLAN_PURCHASE_CHECKOUT_START = 'INSTANCE_PLAN_PURCHASE_CHECKOUT_START';
export const INSTANCE_PLAN_PURCHASE_CHECKOUT_ERROR = 'INSTANCE_PLAN_PURCHASE_CHECKOUT_ERROR';
export const INSTANCE_PLAN_PURCHASE_CHECKOUT_SUCCESSFUL = 'INSTANCE_PLAN_PURCHASE_CHECKOUT_SUCCESSFUL';
export const CLEAR_INSTANCE_PLAN_PURCHASE_CHECKOUT_STORE = 'CLEAR_INSTANCE_PLAN_PURCHASE_CHECKOUT_STORE';

export const INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_START = 'INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_START';
export const INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_ERROR = 'INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_ERROR';
export const INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_SUCCESSFUL = 'INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_SUCCESSFUL';
export const CLEAR_INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_STORE = 'CLEAR_INSTANCE_SUBSCRIBED_PLAN_SUMMARIZED_STORE';

export const INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_START = 'INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_START';
export const INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_ERROR = 'INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_ERROR';
export const INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_SUCCESSFUL = 'INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_SUCCESSFUL';
export const CLEAR_INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_STORE = 'CLEAR_INSTANCE_REGISTRATION_RESEND_COMPLETION_TOKEN_STORE';



// WEBPACK FOOTER //
// ./src/store/modules/instance/mutation-types.js